export const clcPercentage = (width: number, value: number): string => {
  return (value / width) * 100 + '%';
};
